import { createStore } from 'vuex';
import { getDocs, collection, query, where, getDoc, doc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { Users_Collection, Products_Collection } from './global_config'; 

export default createStore({
  state: {
    userData: null,
    allProductsData: [],
    Selected_Option: null,
    Selected_Object: null,
    tutorNetEarnings: 0,
  },
  mutations: {
    setUserData(state, userData) {
      state.userData = userData;
    },
    setTutorNetEarnings(state, amount) {
      state.tutorNetEarnings = amount;
    },

    Update_Selected_Option(state, Selected_Option) {
      state.Selected_Option = Selected_Option;
    },

    Update_Selected_Object(state, Selected_Object) {
      state.Selected_Object = Selected_Object;
    },

    Update_allProductsData(state, allProductsData) {
      state.allProductsData = allProductsData;
    },
  },
  actions: {
    async fetchUserData({ commit }) {
      const auth = getAuth();
      const db = getFirestore();
      const user = auth.currentUser;
      try {
        if (user) {
          const userDoc = await getDoc(doc(db, Users_Collection, user.uid));
          if (userDoc.exists()) {
            commit('setUserData', userDoc.data());
            console.log('Fetched user data');
          } else {
            console.error('User document does not exist');
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },

    async fetchallProductsData({ state, commit }) {
        const db = getFirestore();
        const projectsRef = collection(db, Products_Collection);
    
        const q = query(
          projectsRef,
          where('Product_Seller_ID', '==', state.userData?.User_ID)
        );
    
        try {
          const querySnapshot = await getDocs(q);
          const projects = querySnapshot.docs.map(doc => doc.data());
          
          // Commit the projects data to the store
          commit('Update_allProductsData', projects);
          
          // Log the fetched projects data in the console
          //console.log('Fetched all projects data:', projects);
          console.log('Fetched all products data');

        } catch (error) {
          console.error('Error fetching projects data:', error);
        }
    },
    

    Update_Selected_Option(context, newData) {
      context.commit('Update_Selected_Option', newData);
    },

    Update_Selected_Object(context, newData) {
      context.commit('Update_Selected_Object', newData);
    },
  },
  getters: {
    userData: (state) => state.userData,
    allProductsData: (state) => state.allProductsData,
  },
});
